module.exports = __webpack_public_path__ + "img/desire_003.36ea97e.webp";